import React from "react";
import {
  Eye,
  Target,
  Star,
  Shield,
  Lightbulb,
  Users,
  Leaf,
  Handshake,
} from "lucide-react";
import ValueCard from "../components/ValueCard";
import HeroSection from "../components/HeroSection";
import aboutHero from "../assets/images/about-hero.jpg";

export default function AboutPage() {
  const values = [
    {
      icon: <Star size={40} />,
      title: "Excellence",
      description:
        "We strive for excellence in everything we do, setting the highest standards for quality and performance.",
    },
    {
      icon: <Shield size={40} />,
      title: "Integrity",
      description:
        "We conduct business with honesty, transparency, and unwavering ethical principles.",
    },
    {
      icon: <Lightbulb size={40} />,
      title: "Innovation",
      description:
        "We embrace innovation and continuously seek new ways to improve our services and solutions.",
    },
    {
      icon: <Users size={40} />,
      title: "Collaboration",
      description:
        "We believe in the power of teamwork and partnership to achieve extraordinary results.",
    },
    {
      icon: <Leaf size={40} />,
      title: "Sustainability",
      description:
        "We are committed to sustainable practices that benefit our environment and society.",
    },
    {
      icon: <Handshake size={40} />,
      title: "Client Focus",
      description:
        "We put our clients at the center of everything we do, ensuring their success is our success.",
    },
  ];

  return (
    <>
      <HeroSection
        title="ABOUT US"
        description="Madison Group is a Malawian company that is home to five local businesses spread across various sectors."
        imageUrl={aboutHero}
      />

      <section className="story-section">
        <div className="story-grid">
          <div className="story-content">
            <h2>Our Story</h2>
            <p>
              Madison Group has built a distinguished 17-year legacy,
              establishing ourselves as a trusted partner for both local and
              international clients seeking world-class recruitment outsourcing
              solutions.
            </p>
            <p>
              Throughout our nearly two decades in business, we have
              meticulously cultivated a reputation for reliability, excellence,
              and consistent delivery across diverse industries and markets.
            </p>
            <p>
              Our unwavering commitment to quality service and client
              satisfaction has positioned us as the go-to provider for
              organizations looking to optimize their talent acquisition
              strategies while maintaining the highest standards of
              professionalism and efficiency in every engagement.
            </p>
          </div>
          <div className="story-image">
            <img
              src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=1000&fit=crop&q=80"
              alt="Modern business building"
            />
          </div>
        </div>
      </section>

      <section className="vm-section">
        <div className="vm-container">
          <div className="vm-card">
            <div className="vm-icon">
              <Eye size={48} />
            </div>
            <h3>Our Vision</h3>
            <p>
              To be the premier holding company recognized
              for excellence in service delivery, innovation, and sustainable
              business practices that create lasting value for our clients.
            </p>
          </div>
          <div className="vm-card">
            <div className="vm-icon">
              <Target size={48} />
            </div>
            <h3>Our Mission</h3>
            <p>
              To provide world-class integrated business solutions through our
              specialized subsidiaries, leveraging professionalism, cutting-edge
              technology, and a deep understanding of our clients' needs to
              deliver exceptional results.
            </p>
          </div>
        </div>
      </section>

      <section className="values-section">
        <h2 className="section-title">Our Core Values</h2>
        <div className="values-grid">
          {values.map((value, index) => (
            <ValueCard key={index} {...value} />
          ))}
        </div>
      </section>
    </>
  );
}
